import Swal from "sweetalert2";

// Shared modern popup styling for Task Flow Configuration — buttonsStyling:false so
// Tailwind classes fully control button look instead of SweetAlert2's default flat buttons.
const POPUP_BASE = "rounded-2xl !p-6";
const TITLE_BASE = "!text-lg !font-bold !text-slate-800 !pt-3";
const TEXT_BASE  = "!text-sm !text-slate-500";
const ACTIONS_BASE = "!mt-5 !gap-2.5";
const CANCEL_BTN = "px-5 py-2.5 rounded-xl font-semibold text-slate-600 bg-slate-100 hover:bg-slate-200 cursor-pointer transition-all";

// Destructive confirm (delete / remove)
export const CONFIRM_CLASSES = {
  popup: POPUP_BASE,
  title: TITLE_BASE,
  htmlContainer: TEXT_BASE,
  actions: ACTIONS_BASE,
  confirmButton: "px-5 py-2.5 rounded-xl font-semibold text-white bg-[#ef4444] hover:bg-[#dc2626] cursor-pointer transition-all shadow-[0_4px_14px_rgba(239,68,68,0.35)]",
  cancelButton: CANCEL_BTN,
};

// Input prompt (Enter Priority / Edit Priority) — green to match the page's primary action color
export const INPUT_CLASSES = {
  popup: POPUP_BASE,
  title: TITLE_BASE,
  htmlContainer: TEXT_BASE,
  input: "!rounded-lg !border !border-gray-200 !shadow-none !text-sm !mt-1",
  actions: ACTIONS_BASE,
  confirmButton: "px-5 py-2.5 rounded-xl font-semibold text-white bg-[#10B981] hover:bg-[#0ea975] cursor-pointer transition-all shadow-[0_4px_14px_rgba(16,185,129,.35)]",
  cancelButton: CANCEL_BTN,
  validationMessage: "!rounded-lg !bg-red-50 !text-red-600 !text-xs !font-medium !mt-2",
};

// Slide-in toast for quick, non-blocking feedback instead of a centered modal
export const successToast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2200,
  timerProgressBar: true,
  customClass: { popup: "rounded-xl !text-sm !shadow-lg" },
  didOpen: toast => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});

export const errorToast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2800,
  timerProgressBar: true,
  customClass: { popup: "rounded-xl !text-sm !shadow-lg" },
  didOpen: toast => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});
